function initSqpc(section){
  if(section.dataset.sqpcReady)return;
  section.dataset.sqpcReady='true';
  var track=section.querySelector('[data-sqpc-track]');
  var prev=section.querySelector('[data-sqpc-prev]');
  var next=section.querySelector('[data-sqpc-next]');
  var videos=[].slice.call(section.querySelectorAll('.sqpc-video'));
  if(!track||!prev||!next)return;

  function updateArrows(){
    prev.disabled=track.scrollLeft<=2;
    next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
  }
  function move(direction){
    var card=track.querySelector('.sqpc-card');
    if(!card)return;
    var gap=parseFloat(getComputedStyle(track).columnGap)||0;
    track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  if(section.classList.contains('sqpc--compact')){
    initSqpcViewer(section,videos);
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    track.addEventListener('scroll',updateArrows,{passive:true});
    if('ResizeObserver' in window){
      var resize=new ResizeObserver(updateArrows);
      resize.observe(track);
      (section.closest('.shopify-section')||section).addEventListener('shopify:section:unload',function(){resize.disconnect()},{once:true});
    }else{window.addEventListener('resize',updateArrows)}
    updateArrows();
    return;
  }
  function updateVideo(video){
    var card=video.closest('.sqpc-card');
    var play=card.querySelector('.sqpc-play');
    var sound=card.querySelector('.sqpc-sound');
    var playing=!video.paused;
    play.classList.toggle('is-playing',playing);
    play.setAttribute('aria-pressed',String(playing));
    play.setAttribute('aria-label',(playing?'Pause ':'Play ')+video.getAttribute('aria-label'));
    sound.setAttribute('aria-pressed',String(!video.muted));
    sound.setAttribute('aria-label',(video.muted?'Turn on':'Turn off')+' sound for '+video.getAttribute('aria-label'));
  }
  videos.forEach(function(video){
    video.muted=true;
    video.addEventListener('play',function(){
      videos.forEach(function(other){if(other!==video)other.pause()});
      updateVideo(video);
    });
    video.addEventListener('pause',function(){updateVideo(video)});
    video.addEventListener('ended',function(){updateVideo(video)});
    video.closest('.sqpc-card').querySelector('.sqpc-play').addEventListener('click',function(){
      if(video.paused)video.play().catch(function(){});else video.pause();
    });
    video.closest('.sqpc-card').querySelector('.sqpc-sound').addEventListener('click',function(){
      video.muted=!video.muted;
      updateVideo(video);
    });
    updateVideo(video);
  });
  prev.addEventListener('click',function(){move(-1)});
  next.addEventListener('click',function(){move(1)});
  track.addEventListener('scroll',updateArrows,{passive:true});
  window.addEventListener('resize',updateArrows);
  updateArrows();
  if('IntersectionObserver' in window){
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){if(!entry.isIntersecting)entry.target.pause()});
    },{root:track,threshold:0.2});
    videos.forEach(function(video){observer.observe(video)});
  }
}

function initSqpcViewer(section,videos){
  var dialog=document.createElement('dialog');
  dialog.className='sqpc-viewer';
  dialog.setAttribute('aria-label','Creator video');
  dialog.innerHTML='<div class="sqpc-viewer__head"><span class="sqpc-viewer__caption"></span><button class="sqpc-viewer__close" type="button" aria-label="Close video" autofocus>×</button></div><video class="sqpc-viewer__video" controls playsinline preload="none"></video><p class="sqpc-viewer__status" role="status"></p>';
  section.appendChild(dialog);
  var player=dialog.querySelector('video');
  var caption=dialog.querySelector('.sqpc-viewer__caption');
  var close=dialog.querySelector('.sqpc-viewer__close');
  var status=dialog.querySelector('.sqpc-viewer__status');
  var trigger=null,oldOverflow='',oldPriority='';
  function open(video,button){
    if(dialog.open)return;
    trigger=button;
    caption.textContent=video.getAttribute('aria-label')||'Creator video';
    dialog.setAttribute('aria-label',caption.textContent);
    status.textContent='Loading video…';
    player.poster=video.poster;
    player.src=video.querySelector('source').src;
    if(typeof dialog.showModal!=='function'){
      // Older browsers still get native video playback rather than a dead control.
      window.location.assign(player.src);
      return;
    }
    oldOverflow=document.body.style.getPropertyValue('overflow');
    oldPriority=document.body.style.getPropertyPriority('overflow');
    dialog.showModal();
    document.body.style.setProperty('overflow','hidden','important');
    close.focus();
    var play=player.play();
    if(play&&play.catch)play.catch(function(){if(dialog.open&&!player.error)status.textContent='Tap play to watch.'});
  }
  function cleanup(){
    player.pause();
    player.removeAttribute('src');
    player.removeAttribute('poster');
    player.load();
    document.body.style.setProperty('overflow',oldOverflow,oldPriority);
    if(trigger&&trigger.isConnected)trigger.focus({preventScroll:true});
    trigger=null;
  }
  videos.forEach(function(video){
    var media=video.closest('.sqpc-media');
    var button=media.querySelector('.sqpc-play');
    button.removeAttribute('aria-pressed');
    button.setAttribute('aria-haspopup','dialog');
    button.setAttribute('aria-label','Watch '+video.getAttribute('aria-label'));
    media.addEventListener('click',function(){open(video,button)});
  });
  close.addEventListener('click',function(){dialog.close()});
  // Escape uses native dialog cancellation and focus containment.
  dialog.addEventListener('close',cleanup);
  dialog.addEventListener('click',function(event){
    if(event.target!==dialog)return;
    var rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
  });
  player.addEventListener('playing',function(){status.textContent=''});
  player.addEventListener('canplay',function(){if(!player.paused)status.textContent=''});
  player.addEventListener('error',function(){if(dialog.open)status.textContent='Video could not load. Close and try again.'});
  (section.closest('.shopify-section')||section).addEventListener('shopify:section:unload',function(){if(dialog.open)dialog.close();player.pause()},{once:true});
}
document.querySelectorAll('.sqpc').forEach(initSqpc);
if(!window.sqpcSectionListener){
  window.sqpcSectionListener=true;
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('.sqpc').forEach(initSqpc)});
}
